export class SessionError extends Error {
  constructor(message) {
    super(message)
    this.name = 'SessionError'
  }
}
